import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 bg-brand-petrol text-white" data-id="element-63" data-mp="3udoz2oyozioy">
      <div className="max-w-3xl mx-auto text-center" data-id="element-64" data-mp="c7aew89tyci4">
        <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-3" data-id="element-65" data-mp="c4o6k6f47syu">
          ONE LAST CHANCE
        </p>

        <p className="text-base sm:text-lg mb-5 leading-relaxed" data-id="element-66" data-mp="m4yilnpeyucf">
          Your clients deserve the best version of you — not an exhausted one.
          Stop spending your Sundays programming. Take back control of your
          coaching career with professional tools built for real results.
        </p>

        <div className="bg-white/10 border-2 border-white/20 rounded-xl p-5 mb-6" data-id="element-67" data-mp="qvx5x78tksp6">
          <p className="text-base mb-2" data-id="element-68" data-mp="14vg00w4sq3ih">
            FUNCTIONAL PRO™ 6-in-1 Complete System + 5 Professional Bonuses
          </p>
          <p className="text-xl line-through opacity-70 mb-1" data-id="element-69" data-mp="zx4qynmbrx1b">$97 USD</p>
          <p className="text-4xl font-serif font-bold" data-id="element-70" data-mp="2c4ocezz2fd7s">Only: $27 USD</p>
        </div>

        <CTAButton href="https://functionalpro.impultienda.ar/checkout" className="max-w-md mx-auto !bg-brand-gold !text-brand-graphite !border-white text-base sm:text-lg py-4 shadow-2xl ring-4 ring-brand-gold/40 hover:!bg-white hover:!text-brand-petrol hover:scale-[1.02]" data-id="element-71" data-mp="2c7125zb2erve">
          🚀 YES, I WANT MY FUNCTIONAL PRO™ SYSTEM
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm mt-5 opacity-90" data-id="element-72" data-mp="2v38y2ci6tqe1">
          <div className="flex items-center gap-1" data-id="element-73" data-mp="300ivoffqd8cy">
            <Zap className="w-4 h-4" data-id="element-74" data-mp="34t28vbaia1h8" />
            <span data-id="element-75" data-mp="34u3u28l8k4co">Immediate Access — Delivered Instantly by Email</span>
          </div>
          <span className="hidden sm:inline" data-id="element-76" data-mp="39rvopad9m4kk">•</span>
          <div className="flex items-center gap-1" data-id="element-77" data-mp="3errosyiudbuu">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-78" data-mp="3etcnn0c6vgyi" />
            <span data-id="element-79" data-mp="3iu4whsh5fju9">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline" data-id="element-80" data-mp="1jntsxxt8i5zx">•</span>
          <div className="flex items-center gap-1" data-id="element-81" data-mp="1jolesgx14pd0">
            <Shield className="w-4 h-4" data-id="element-82" data-mp="1eq1oy5fbetfd" />
            <span data-id="element-83" data-mp="1er3aj3tyiybc">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}